
import { computed, defineComponent, onBeforeUnmount, onMounted } from 'vue'

import useImpersonate from '@/common/composable/useImpersonate'
import useJiraWidget from '@/common/composable/useJiraWidget'

import { useConnectionStore } from '@/store/connectionStore'

// composable
import { useTitle } from 'vue-composable'

export default defineComponent({
    setup() {
        const connectionStore = useConnectionStore()
        const jira_widget = useJiraWidget()

        const isProdVersion = computed(() => window.location.href.includes('bpms.spark.kz'))

        useImpersonate()

        const setTitle = () => {
            if (isProdVersion.value) {
                useTitle('Spark BPMS')
            } else {
                useTitle('Spark BPMS - DEV')
            }
        }

        onMounted(() => {
            setTitle()

            jira_widget.install()
            connectionStore.addListeners()
        })

        onBeforeUnmount(() => {
            jira_widget.destroy()
            connectionStore.removeListeners()
        })
    },
})
